var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function convertUTCToLocal(date) {
  return new Date(new Date(date).getTime() + (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3);
}
__name(convertUTCToLocal, "convertUTCToLocal");
export {
  convertUTCToLocal
};
